export const LOGOUT_REASONS = {
  ONBOARDING_STOPPED: 'onboarding_stopped',
  BUSINESS_BLOCKED: 'business_blocked',
  DEFAULT_LOGOUT: 'default_logout',
  PARTNER_APP: 'partner_app',
  EXPIRED_SESSION: 'expired_session',
  BUSINESS_DETAILS_ERROR: 'business_details_error',
} as const

export type LogoutReason = ValueOf<typeof LOGOUT_REASONS>
